import { getRecoil, setRecoil } from 'recoil-nexus';

import { requestApi } from 'api/Api';

import { socketEmit } from 'lib/clients/socket';

import state from 'components/state';

const onAuthReq = async () => {
  let socketSessionTokenState = getRecoil(state.socketSessionTokenState);
  if (!socketSessionTokenState) {
    const resData = await requestApi({
      url: '/api/user/check_token',
      navigate: () => {}
    });
    const { socketSession } = resData;
    setRecoil(state.socketSessionTokenState, socketSession);
    socketSessionTokenState = socketSession;
  }
  socketEmit('user-auth', { token: socketSessionTokenState });
};

export default onAuthReq;
